import { render, staticRenderFns } from "./BadgeDelete.vue?vue&type=template&id=9cb894e0"
import script from "./BadgeDelete.vue?vue&type=script&lang=js"
export * from "./BadgeDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports